<template>
    <div>
        <register-modal
            :visible="showRegister"
            @close="showRegister = false"
            @switch-to-login="showRegister = false; showLogin = true"
            @register-success="onRegisterSuccess"
        />
        <login-modal
            :visible="showLogin"
            @close="showLogin = false"
            @switch-to-register="showLogin = false; showRegister = true"
            @switch-to-forgot="showLogin = false; showForgot = true"
            @login-success="onLoginSuccess"
        />
        <forgot-password-modal
            :visible="showForgot"
            @close="showForgot = false"
            @switch-to-login="showForgot = false; showLogin = true"
        />
    </div>
</template>

<script>
import { overridable } from '@/core/template-engine';

// Owns the login / register / forgot-password modals. Open them from anywhere with
// `$root.$emit('open-login')` or `$root.$emit('open-register')`.
export default {
    name: 'AuthModals',
    components: {
        LoginModal: overridable('LoginModal', () => import(/* webpackChunkName: "auth" */ './LoginModal.vue')),
        RegisterModal: overridable('RegisterModal', () => import(/* webpackChunkName: "auth" */ './RegisterModal.vue')),
        ForgotPasswordModal: overridable('ForgotPasswordModal', () => import(/* webpackChunkName: "auth" */ './ForgotPasswordModal.vue'))
    },
    data() {
        return {
            showRegister: false,
            showLogin: false,
            showForgot: false
        };
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.syncRegisterFromRoute();
            }
        }
    },
    created() {
        this.$root.$on('open-register', this.openRegister);
        this.$root.$on('open-login', this.openLogin);
    },
    beforeDestroy() {
        this.$root.$off('open-register', this.openRegister);
        this.$root.$off('open-login', this.openLogin);
    },
    methods: {
        openRegister() {
            this.showLogin = false;
            this.showForgot = false;
            this.showRegister = true;
        },
        openLogin() {
            this.showRegister = false;
            this.showForgot = false;
            this.showLogin = true;
        },
        syncRegisterFromRoute() {
            const path = this.$route.path.replace(/\/$/, '') || '/';
            if (path !== '/register') return;
            const agentUsername = this.$route.query.username;
            if (agentUsername) {
                localStorage.setItem('agentCode', agentUsername);
            } else {
                localStorage.removeItem('agentCode');
            }
            if (localStorage.getItem('gamingToken')) return;
            this.showRegister = true;
        },
        onLoginSuccess() {
            this.showLogin = false;
            this.$root.$emit('login-state-changed');
            this.$root.$emit('fetch-member-info');
        },
        onRegisterSuccess(data) {
            this.showRegister = false;
            if (data?.data?.token) {
                localStorage.setItem('gamingToken', data.data.token);
                this.$root.$emit('login-state-changed');
                this.$root.$emit('fetch-member-info');
            }
        }
    }
};
</script>
